export default __webpack_public_path__ + "static/media/citroen.e69d3380.webp";